var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9362,
    cy: 50.0001,
    r: 30.3937,
    stroke: "url(#paint0_linear_623_5225)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2863 67.7874V32.2129H51.6276V67.7874H50.2863ZM58.2098 42.8853C58.0623 41.1158 57.3433 39.6845 56.0526 38.5913C54.7712 37.4981 53.1118 36.9515 51.0745 36.9515C49.7009 36.9515 48.4794 37.2063 47.41 37.7158C46.3406 38.2254 45.5017 38.9202 44.8932 39.8003C44.2848 40.6804 43.9806 41.6902 43.9806 42.8297C43.9806 43.5615 44.1189 44.2239 44.3954 44.8168C44.6812 45.4005 45.0822 45.9239 45.5985 46.3871C46.1147 46.8411 46.7278 47.2394 47.4376 47.5822C48.1475 47.925 48.9311 48.2261 49.7884 48.4855L52.886 49.4026C53.9461 49.7269 54.9233 50.1021 55.8176 50.5282C56.721 50.9544 57.5046 51.4639 58.1684 52.0568C58.8413 52.6405 59.3622 53.326 59.7309 54.1135C60.1089 54.9009 60.2979 55.8088 60.2979 56.8371C60.2979 58.3379 59.9107 59.6812 59.1363 60.8671C58.3712 62.0529 57.2787 62.9886 55.859 63.6741C54.4486 64.3504 52.7846 64.6886 50.867 64.6886C49.0417 64.6886 47.4515 64.3782 46.0963 63.7575C44.7503 63.1368 43.6856 62.2752 42.902 61.1728C42.1184 60.0611 41.6759 58.7826 41.5745 57.3374H43.3445C43.4367 58.514 43.81 59.533 44.4646 60.3946C45.1283 61.2469 46.0087 61.9047 47.1058 62.3679C48.2028 62.8311 49.4566 63.0627 50.867 63.0627C52.3881 63.0627 53.7295 62.8033 54.8911 62.2845C56.0526 61.7564 56.9607 61.0246 57.6152 60.0889C58.2698 59.1532 58.597 58.0646 58.597 56.8232C58.597 55.8227 58.3619 54.9658 57.8918 54.2524C57.4216 53.5391 56.7256 52.923 55.8037 52.4042C54.8911 51.8854 53.7571 51.4222 52.402 51.0146L49.097 50.0141C46.8845 49.3378 45.1929 48.416 44.0221 47.2487C42.8605 46.0814 42.2797 44.6269 42.2797 42.8853C42.2797 41.4215 42.6669 40.1245 43.4413 38.9943C44.2157 37.8548 45.2666 36.9608 46.5941 36.3123C47.9308 35.6638 49.4381 35.3396 51.1159 35.3396C52.803 35.3396 54.2918 35.6684 55.5825 36.3262C56.8731 36.9747 57.8964 37.8687 58.6523 39.0082C59.4083 40.1384 59.8277 41.4308 59.9107 42.8853H58.2098Z",
    fill: "url(#paint1_linear_623_5225)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3733 5.99998L42.8044 7.69819L35.7863 14.2188",
    stroke: "url(#paint2_linear_623_5225)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6334 33.9237L92.934 43.3481L86.4088 36.335",
    stroke: "url(#paint3_linear_623_5225)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7558 94L57.3247 92.302L64.3428 85.7812",
    stroke: "url(#paint4_linear_623_5225)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 66.7124L7.69942 57.288L14.2246 64.3011",
    stroke: "url(#paint5_linear_623_5225)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9491 76.8169C76.6402 84.5084 67.8163 89.7835 57.997 91.7322",
    stroke: "url(#paint6_linear_623_5225)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7121 82.928C15.0298 76.5894 9.80034 67.7721 7.92435 57.9949",
    stroke: "url(#paint7_linear_623_5225)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4593 22.7686C22.8657 15.1563 31.7561 9.99164 41.5995 8.16557",
    stroke: "url(#paint8_linear_623_5225)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3439 17.574C85.9727 23.9903 91.0996 32.8368 92.843 42.5889",
    stroke: "url(#paint9_linear_623_5225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_5225",
    x1: 81.8298,
    y1: 25.0619,
    x2: -38.3949,
    y2: 116.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_5225",
    x1: 60.2979,
    y1: 35.6418,
    x2: 10.7028,
    y2: 55.5218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_5225",
    x1: 41.0361,
    y1: 14.2187,
    x2: 33.5309,
    y2: 3.95251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_5225",
    x1: 93.0913,
    y1: 43.3481,
    x2: 84.0665,
    y2: 33.9596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_623_5225",
    x1: 64.9875,
    y1: 94,
    x2: 57.4823,
    y2: 83.7338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_623_5225",
    x1: 12.6825,
    y1: 66.7124,
    x2: 3.65766,
    y2: 57.3239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_623_5225",
    x1: 93.064,
    y1: 15.2375,
    x2: -74.9951,
    y2: 144.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_623_5225",
    x1: 93.3196,
    y1: 76.9301,
    x2: -4.1877,
    y2: -4.69729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_623_5225",
    x1: 22.3245,
    y1: 93.064,
    x2: 103.45,
    y2: -4.69354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_623_5225",
    x1: 6.93628,
    y1: 23.0851,
    x2: 104.007,
    y2: 105.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B246FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivables);
export default __webpack_public_path__ + "static/media/receivables.ed406453943dbd4bfadb9f62412e6f36.svg";
export { ForwardRef as ReactComponent };